/**
 * @fileoverview React context that handles getting config that is loaded from the backend.
 *
 * @format
 */

import { createContext, useContext } from 'react';
import { AppConfig } from '../models/config';

interface ConfigContextType {
  config: AppConfig[];
  getConfigByName: (name: string) => AppConfig | null;
}

export const ConfigContext = createContext<ConfigContextType>({
  config: [],
  getConfigByName: (name: string) => null,
});

interface ConfigProviderProps {
  children: React.ReactNode;
  config: AppConfig[];
}

export const ConfigProvider = ({ children, config }: ConfigProviderProps) => {
  return (
    <ConfigContext.Provider
      value={{
        config,
        getConfigByName(name) {
          return config.find((c) => c.name === name) || null;
        },
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
